<modal-panel title="Traveler Payment Details" (close)="closeDialog()">
  <app-kt-payment-detail [data]="data.id"></app-kt-payment-detail>
  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
  </ng-container>
</modal-panel>
